import { Grid, TextField } from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { noticeToCreditorsFlow } from "../index";
import * as Yup from "yup";
import { Formik, FormikHelpers } from "formik";
import { OUTCOMES } from "../../../constants";
import { ScreenFlowFormButtons } from "../shared/ScreenFlowFormButtons";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";

interface Values {
  dateOfBirth: string;
}

export const DateOfBirth = (): JSX.Element => {
  const navigate = useNavigate();
  const { screenName } = useParams();
  const currentScreen = noticeToCreditorsFlow.getCurrentFlowScreen(screenName);

  // https://formik.org/docs/api/formik
  const formikInit = {
    values: {
      dateOfBirth: "",
    },
    schema: Yup.object().shape({
      dateOfBirth: Yup.string().required(),
    }),
  };

  const handleSubmit = async (
    values: Values,
    { setSubmitting, setStatus }: FormikHelpers<Values>
  ) => {
    setStatus("");
    try {
      if (!currentScreen) throw Error("couldn't determine currentScreen");

      // TODO: save to database

      noticeToCreditorsFlow.navigateToNext(
        currentScreen,
        OUTCOMES.complete,
        navigate
      );
    } catch (error) {
      setStatus("Sorry, error: " + ((error as Error)?.message || ""));
      // console.error(error);
      setSubmitting(false);
    }
  };

  return currentScreen ? (
    <FlowScreenWrapper title="When was [Jacob] born?">
      <Formik
        initialValues={formikInit.values}
        validationSchema={formikInit.schema}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
          status,
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid
              container
              spacing={1}
              sx={{
                my: 1,
              }}
            >
              <Grid item xs={12}>
                <TextField
                  error={Boolean(touched.dateOfBirth && errors.dateOfBirth)}
                  fullWidth
                  helperText={touched.dateOfBirth && errors.dateOfBirth}
                  label="Date of birth"
                  margin="normal"
                  name="dateOfBirth"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="date"
                  value={values.dateOfBirth}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <ScreenFlowFormButtons
                  isSubmitting={isSubmitting}
                  status={status}
                  onBack={() => navigate(-1)}
                />
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
